import React, { useState } from 'react';
import RenderInBody from 'components/shared/render_in_body';
import ModalContainer from 'components/shared/modal/modal_container';
import { Icon } from 'components/ui';
import MultipleChoiceBody from './MultipleChoiceBody';

const ElementHelperModal = ({
  dismissCallback,
  content,
  handleUpdate,
  applyChanges,
}) => {
  const [isErrorShown, setError] = useState(false);
  const renderBody = () => {
    switch (content.question_type) {
      case 'multiple_choice':
      case 'multiple_select':
        return (
          <MultipleChoiceBody
            content={content}
            dismissCallback={dismissCallback}
            setError={setError}
            handleUpdate={handleUpdate}
            applyChanges={applyChanges}
          />
        );
      default:
        return <p>Error</p>;
    }
  };

  return (
    <RenderInBody>
      <ModalContainer
        onEscape={dismissCallback}
        className="ContentHelperModal Modal-background"
      >
        <div className="Modal-container ContentHelperModal-container">
          <div
            className="ModalTakeover-closeButton"
            role="button"
            tabIndex="0"
            onClick={dismissCallback}
            onKeyDown={e => e.key === 'Enter' && dismissCallback()}
          >
            <Icon name="remove" />
          </div>
          <div className="ContentHelperModal-body">
            <div className="ContentHelperModal-directions">
              <div className="ContentHelperModal-header">
                {t('questions.question.element_helper.title')}
              </div>
              <div className="ContentHelperModal-description">
                {t('questions.question.element_helper.description')}
              </div>
            </div>
            {renderBody()}
            {isErrorShown && (
              <div className="ErrorContainer ContentHelperModal-errorMessage p-4 mt-10">
                {t('questions.question.element_helper.error')}
              </div>
            )}
          </div>
        </div>
      </ModalContainer>
    </RenderInBody>
  );
};

export default ElementHelperModal;
